export default {
  title01: "Τρέχουσα Καιρική Κατάσταση",
  title02: "24 Ώρες",
  title03: "Προβολή 10-ήμερης Πρόβλεψης Καιρού",
  title04: "Δείκτης Ποιότητας Αέρα (ΔΠΑ)",
  title05: "Δείτε όλες τις πληροφορίες",
  title06: "ΑΝΑΤΟΛΗ ΚΑΙ ΔΥΣΗ ΗΛΙΟΥ",
  title07: "ΦΑΣΗ ΤΗΣ ΣΕΛΗΝΗΣ",
  title08: "Η επόμενη πανσέληνος",
  title09: "Η επόμενη νέα σελήνη",
  title10: "ημέρα",
  title11: "ΝΥΧΤΑ",
  title12: "ανατολή ηλίου",
  title13: "Ηλιοβασίλεμα",
  title14: "ανατολή του φεγγαριού",
  title15: "Δύση του φεγγαριού",
  title16: "πηγή",
  title17: "αρχή",
  title18: "τέλος",
  title19: "Χρησιμοποιήστε την Τρέχουσα τοποθεσία",
  title20: "Ψάξτε την πόλη",
  title21: "Αισθάνεται σαν",
  title22: "Μοιάζει με σκιά",
  title23: "Τώρα",
  title24: "Σήμερα",
  title25: "ΗΛΙΟΣ",
  title26: "Δευτέρα",
  title27: "Τρίτη",
  title28: "Τετάρτη",
  title29: "Πέμπτη",
  title30: "Παρασκευή",
  title31: "Σάββατο",
  title32: "Φόρτωση...",
  title33: "τώρα",
  title34: "Ωριαίος",
  title35: "Καθημερινά",
  title36: "Ήλιος & Σελήνη",
  title37: "Ποιότητα αέρα",
  title38: "Επικοινωνία στο: xlf550402@gmail.com",
  title39: "Συμφωνία Απορρήτου",
  title40: "Πνευματικά Δικαιώματα © comfortweather.com 2020 - 2024. Με επιφύλαξη παντός δικαιώματος.",
  title41: "Δεδομένα παρέχονται από",
  title42: "Υψηλά",
  title43: "Χαμηλά",
  title44: "Αποδοχή",
  title45:
    "Ευχαριστούμε που χρησιμοποιείτε το ComfortWeather! Για την καλύτερη προστασία των νομικών σας δικαιωμάτων και συμφερόντων, παρακαλώ διαβάστε προσεκτικά την ",
  title46: "Πολιτική Απορρήτου",
  title47: " πριν από τη χρήση.",
  title48: "",
  title49: "Επικοινωνία στο: xyjph123@gmail.com",
  title50: "Πνευματικά Δικαιώματα © 24hweather.com 2020 - 2024. Με επιφύλαξη παντός δικαιώματος.",
  title51:
    "Ευχαριστούμε που χρησιμοποιείτε το 24hweather! Για την καλύτερη προστασία των νομικών σας δικαιωμάτων και συμφερόντων, παρακαλώ διαβάστε προσεκτικά την ",
};
